/* unplugin-vue-components disabled */import { render } from "./TeachingPlanEditorView.vue?vue&type=template&id=47f74eee&scoped=true"
import script from "./TeachingPlanEditorView.vue?vue&type=script&lang=js"
export * from "./TeachingPlanEditorView.vue?vue&type=script&lang=js"

import "./TeachingPlanEditorView.vue?vue&type=style&index=0&id=47f74eee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f74eee"]])

export default __exports__